import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Linkedin, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Team', path: '/team' },
    { name: 'NT Benefits', path: '/nt-benefits' },
    { name: 'Pay Invoice', path: '/pay' },
    { name: 'Contact', path: '/#contact' },
  ];

  const serviceLinks = [
    { name: 'Technical Advisory', path: '/services/technical-advisory' },
    { name: 'Sourcing', path: '/services/sourcing' },
    { name: 'Products Trading', path: '/services/products' },
    { name: 'Renewable Energy', path: '/services/renewable-energy' },
  ];

  return (
    <footer className="relative z-10 mt-24">
      <div className="max-w-6xl mx-auto px-6">
        {/* Top card */}
        <div className="rounded-[2rem] bg-white/60 backdrop-blur-xl border border-white/80 shadow-[0_8px_32px_-12px_rgba(80,50,20,0.12)] p-10 md:p-14">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
            {/* Brand */}
            <div className="lg:col-span-2">
              <Link to="/" className="inline-flex items-center gap-2 mb-5" aria-label="GSD — Global Sales & Distribution">
                <img src="/logo.png" alt="GSD" className="h-14 w-auto object-contain" />
              </Link>
              <p className="text-[#5a4a3a] text-sm leading-relaxed max-w-md mb-6">
                A boutique multi-commodity physical brokerage and trading house — supply chain management of energy, raw materials, and base metals.
              </p>
              <div className="flex items-center gap-3">
                <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full bg-white/70 backdrop-blur-lg border border-white/80 flex items-center justify-center text-[#5a4a3a] hover:text-[#2a2420] hover:bg-white transition-all">
                  <Linkedin className="w-4 h-4" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-[#8b5a2b] font-medium mb-4 uppercase tracking-[0.2em] text-xs">Explore</h4>
              <ul className="space-y-2.5">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-[#5a4a3a] hover:text-[#2a2420] transition-colors text-sm">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-[#8b5a2b] font-medium mb-4 uppercase tracking-[0.2em] text-xs">Services</h4>
              <ul className="space-y-2.5">
                {serviceLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.path} className="text-[#5a4a3a] hover:text-[#2a2420] transition-colors text-sm">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Offices */}
            <div>
              <h4 className="text-[#8b5a2b] font-medium mb-4 uppercase tracking-[0.2em] text-xs">Offices</h4>
              <ul className="space-y-4 text-sm text-[#5a4a3a]">
                <li>
                  <div className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 text-[#c9a962] mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="text-[#2a2420] font-medium mb-0.5">Darwin</div>
                      <div className="text-xs leading-relaxed">Suite J, 34 McLachlan St<br/>Darwin NT 0800</div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 text-[#c9a962] mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="text-[#2a2420] font-medium mb-0.5">Singapore</div>
                      <div className="text-xs leading-relaxed">4 Shenton Way<br/>SGX Centre 2</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* CTA strip inside card */}
          <div className="mt-10 pt-8 border-t border-[#8b5a2b]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <p className="font-serif-display italic text-lg text-[#2a2420]">"Discreet, considered, unhurried."</p>
            <Link
              to="/#contact"
              className="group inline-flex items-center gap-2 bg-[#2a2420] hover:bg-[#1a1410] text-[#fbf8f3] text-sm font-medium px-6 py-3 rounded-full transition-all hover:scale-[1.02]"
            >
              Start a conversation
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 py-8 text-xs text-[#5a4a3a]">
          <div>© {currentYear} Global Sales &amp; Distribution. Darwin · Singapore.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-[#2a2420] transition-colors">Privacy</Link>
            <Link to="/conditions" className="hover:text-[#2a2420] transition-colors">Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
